var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0.895563L49.8411 15.5192L50.0263 15.7944L50.3518 15.7307L67.651 12.349L64.2693 29.6482L64.2056 29.9737L64.4808 30.1589L79.1044 40L64.4808 49.8411L64.2056 50.0263L64.2693 50.3518L67.651 67.651L50.3518 64.2693L50.0263 64.2056L49.8411 64.4808L40 79.1044L30.1589 64.4808L29.9737 64.2056L29.6482 64.2693L12.349 67.651L15.7307 50.3518L15.7944 50.0263L15.5192 49.8411L0.895563 40L15.5192 30.1589L15.7944 29.9737L15.7307 29.6482L12.349 12.349L29.6482 15.7307L29.9737 15.7944L30.1589 15.5192L40 0.895563Z",
    fill: "#F34C78",
    stroke: "#FFB3C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerStar);
export default __webpack_public_path__ + "static/media/hamburger-star.95e8b12a9bf77a221f831b5b9d244b5d.svg";
export { ForwardRef as ReactComponent };